import gql from 'graphql-tag'

export const GET_SINGLE_SESSIONS = gql`
  query GetSingleSession($getSessions: SingleSessionInput!) {
    getSessions(getSessions: $getSessions) {
      ServiceStatus {
        Success
        StatusCode
        Timestamp
        Message
      }
      ServiceResult {
        Suggested {
          Units
          TimeZone
          SessionId
          LearningCenter {
            Name
            Id
          }
          Instructor {
            Photo
            Name
            Id
            Avatar
          }
          StartDatetime
          EndDateTime
          Datetime
          ClassType
        }
      }
    }
  }
`

export const BOOK_SESSIONS = gql`
  mutation PostSession($Sessions: [CreateSessionInput!]!) {
    bookSessions(createSessionInput: $Sessions) {
      ServiceStatus {
        Success
        StatusCode
        Timestamp
        Message
      }
      ServiceResult {
        Status
      }
    }
  }
`

export const CANCEL_SESSIONS = gql`
  mutation PostCancelSessions($Ids: [String!]!, $CancellationReason: String!) {
    cancelSessions(cancelSessionsInput: { Ids: $Ids, CancellationReason: $CancellationReason }) {
      ServiceStatus {
        Success
        StatusCode
        Timestamp
        Message
      }
      ServiceResult {
        Status
      }
    }
  }
`

export const GET_RESCHEDULE_SESSIONS_SUGGESTIONS = gql`
  mutation GetRescheduledSessionsSuggestions($Session: RescheduleSessionInput!) {
    rescheduleSession(rescheduleSessionInput: $Session) {
      ServiceStatus {
        Success
        StatusCode
        Timestamp
        Message
      }
      ServiceResult {
        Suggested {
          Units
          TimeZone
          SessionId
          LearningCenter {
            Name
            Id
          }
          Instructor {
            Photo
            Name
            Id
          }
          StartDatetime
          EndDateTime
          Datetime
          ClassType
        }
      }
    }
  }
`

export const CONFIRM_RESCHEDULE = gql`
  mutation ConfirmReschedule($Session: ConfirmRescheduleSessionInput!) {
    confirmRescheduleSession(confirmRescheduleSessionInput: $Session) {
      ServiceStatus {
        Success
        StatusCode
        Timestamp
        Message
      }
      ServiceResult {
        Status
        Error {
          message
          errorCode
        }
      }
    }
  }
`
